import {Component, Input, OnInit} from '@angular/core';

import packageJson from '../../../../../package.json';

@Component({
  selector: 'am-login-footer',
  templateUrl: './login-footer.component.html',
  styleUrls: ['./login-footer.component.scss'],
})
export class LoginFooterComponent implements OnInit {

  @Input() isLanguageSwitchVisible = true;

  readonly version: string = packageJson.version;

  constructor() {
  }

  ngOnInit(): void {
  }

}
